export default __webpack_public_path__ + "static/media/completed-lane-check.17dd0337.svg";